import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../../store";
import {ServiceCentre} from "../../types";
import {deleteServiceCentre, setModalName} from "../../store/actions";
import {Button, Typography} from "antd";
import {useCallback} from "react";
const { Text, Title } = Typography;

export default function DeleteServiceCentreForm() {
    const dispatch = useDispatch();
    const { selectedServiceCentre } = useSelector<
        AppState,
        AppState["serviceCentres"]
    >((state) => state.serviceCentres);

    const onDelete = () => {
        dispatch(deleteServiceCentre(selectedServiceCentre?.id || ""));
    };

    const onCancel = useCallback(() => {
        dispatch(setModalName(undefined));
    }, [dispatch]);


    return (
        <section className="delete-modal">
            <Title level={5}>Archive Service Center</Title>
            <Text type="secondary">
                Are you sure you want to archive {" "}
                <strong>
                    “{selectedServiceCentre?.serviceCentreName}”
                </strong>{" "}
                ?
            </Text>
            <div className="action-btn-container">
                <Button className="cancel-btn" onClick={onCancel}>
                    Cancel
                </Button>
                <Button type="primary" danger onClick={onDelete}>
                    Delete
                </Button>
            </div>
        </section>
    );
}